<template>
    <div class="col-12">
        <div class="panel panel-default">
            <div class="panel-heading bundle-header">
                {{title}}
            </div>
            <div class="panel-body">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'np-panel',
        props: ['title']
    }
</script>
